export default "__VITE_ASSET__51180798__"